import { render, staticRenderFns } from "./partner-registry-grid.vue?vue&type=template&id=12bdb6d2&scoped=true&"
import script from "./partner-registry-grid.ts?vue&type=script&lang=ts&"
export * from "./partner-registry-grid.ts?vue&type=script&lang=ts&"
import style0 from "./partner-registry-grid.scss?vue&type=style&index=0&id=12bdb6d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bdb6d2",
  null
  
)

export default component.exports